module.exports = __webpack_public_path__ + "static/media/name-logo.c6760f78.png";